module.exports = __webpack_public_path__ + "media/images/landing/iPhone 11 Pro-78b1ec1a6d247ae97688725737460d5d.png";